import React from 'react'
import tick from "../../assets/tick.png"
import Treadmill from "../../assets/Treadmill.jpg"
import Interior from "../../assets/Interior.jpg"
import Equipment from "../../assets/Equiment.jpg"
import Reciption from "../../assets/Reciption.jpg"
import './Choose.css'
const Choose = () => {
  return (
    <div className="Chooses" id="chooses">
      
        <div className="left-c">
            <span><span>WHY</span> CHOOSE US</span>
            <span className='change'>Reasons</span>
            <img src={tick} alt="" />
            <img src={tick} alt="" />
            <img src={tick} alt="" />
            <img src={tick} alt="" />
        </div>
        <div className="right-c">
            <img src={Treadmill} alt="" />
            <img src={Interior} alt="" />
            <img src={Reciption} alt="" />
            <img src={Equipment} alt="" />
        </div>
    </div>
  )
}

export default Choose
